import axios from "axios";
import { MODEL_BASEURL_V1 } from "../baseUrls";

class historicAnalysesAPI {
  async getHistoricStatsApi() {
    return axios.get(
      `${MODEL_BASEURL_V1}/statistics/`,
    );
  }
  async getAnalysesListApi({ page = 1, pageSize = 20, ...filters } = {}) {
    const params = { page, page_size: pageSize };
    // only send the filters the user actually filled in
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== "" && value != null) params[key] = value;
    });
    return axios.get(
      `${MODEL_BASEURL_V1}/statistics/history`,
      { params },
    );
  }
  async getAnalysisByIdApi(analysisId) {
    return axios.get(
      `${MODEL_BASEURL_V1}/fire-analysis/${analysisId}`,
    );
  }
  async deleteAnalysisByIdApi(analysisId) {
    return axios.delete(
      `${MODEL_BASEURL_V1}/fire-analysis/${analysisId}`,
    );
  }
  async getReportByAnalysisIdApi(analysisId) {
    return axios.get(
      `${MODEL_BASEURL_V1}/reports/analysis/${analysisId}`,
      { responseType: "blob" },
    );
  }
  async getStatsByIdsApi(analysisIds) {
    return axios.post(
      `${MODEL_BASEURL_V1}/statistics/by-ids`,
      { analysis_ids: analysisIds },
    );
  }
  async getCostsAnalysesApi({ page = 1, pageSize = 20, ...filters } = {}) {
    const params = { page, page_size: pageSize };
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== "" && value != null) params[key] = value;
    });
    return axios.get(
      `${MODEL_BASEURL_V1}/statistics/valued`,
      { params },
    );
  }
}

export default historicAnalysesAPI;
